<template>
  <validation-provider v-slot="{ errors, classes }" :name="name" :rules="rules" :vid="vid"
                       class="tw-flex tw-flex-col tw-flex-1 tw-relative" tag="div">
    <div class="form-input-field tw-flex tw-flex-col tw-flex-1 tw-relative">
      <div class="tw-flex tw-items-center">
        <i v-if="icon" :class="icon" class="tw-text-sm tw-mb-2 tw-mr-2"></i>
        <label v-if="label" :for="name" class="form-label" v-text="label"></label>
      </div>
      <div :class="[classes, {'type-number': type === 'number'}]" class="form-input-wrapper tw-flex tw-relative">
        <template v-if="type !== 'number'">
          <input v-model="currentValue" v-autofocus="autofocus" :placeholder="placeholder" :type="type"
                 class="tw-flex-1 v2-input form-control" @keydown="keyDown($event)">
        </template>
        <template v-else>
          <input v-model="currentValue" v-autofocus="autofocus" :min="min" :placeholder="placeholder"
                 :step="step" :type="type" class="tw-flex-1 v2-input form-control" @keydown="keyDown($event)">
        </template>
      </div>
      <span v-if="errors.length > 0" class="form-validation-error">{{ errors[0] }}.</span>
      <p v-if="helper" class="helper" v-html="helper"></p>
    </div>
  </validation-provider>
</template>

<script>
import FormInput from '../../../mixins/FormInput';
import Validation from '../../../mixins/FormValidation';

export default {
	name: 'FormInput',

	mixins: [FormInput, Validation],

	props: {
		min: {
			required: false,
		},
		step: {
			required: false,
		},
		autofocus: {
			default: false,
		},
	},

	methods: {
		keyDown(e) {
			if (this.disable_spacebar && e.keyCode === 32) {
				e.preventDefault();
			}

			if (this.disable_keys.includes(e.keyCode)) {
				e.preventDefault();
			}

			this.$emit('keydown', e);
		},
	},
};
</script>

<style lang="scss" scoped>
.required {
  @apply tw-no-underline;
}

.form-validation-error {
  @apply tw-block tw-text-red-600 tw-text-sm tw-font-semibold tw-mt-2;
}
</style>